export const RECRUITER_ID = 'recruiterId';
export const COMPANY_NAME = 'companyName';
export const RECRUITER_PHOTO_URL = 'recruiterPhotoUrl';
export const RECRUITER_LAST_NAME = 'recruiterLastName';
export const RECRUITER_FIRST_NAME = 'recruiterFirstName';
